import _ from "lodash";
import Intro from "./Intro";
import { useBookStore } from "stores/bookStore";
import { useAppStore } from "stores/appStore";
import { DOCUMENT_CATEGORY_SACH_ON_THI_THPT } from "consts/book";

export default function SectionSachOnthiTHPT() {
  const documents = useBookStore((state) => state.documents);
  const gradeId = useAppStore((state) => state.gradeId);
  const documentsOfCurrentGrade = _.get(documents, [gradeId], []);
  const gtsDocuments = documentsOfCurrentGrade.filter(
    (item) => item.category === DOCUMENT_CATEGORY_SACH_ON_THI_THPT
  );

  return (
    !_.isEmpty(gtsDocuments) && (
      <div className="col-md-12 result">
        <Intro
          data={gtsDocuments}
          categoryBook="Sách ôn thi"
          col="col-6 col-lg-3"
          background="#fff"
        />
      </div>
    )
  );
}
